import { useLive } from '../live';
import {hasFeature} from '../../../shared/device-profile.js';
import {DailyMeasurements} from '../components/DailyMeasurements';
import { Text } from '../copy';
import React from 'react';
import { StyleSheet, View } from 'react-native';
import type { QsmartActions } from '../domain/types';
import { featuresForTab } from '../domain/featureCatalog';
import { useTokens } from '../theme/tokens';
import { FeatureList } from '../components/FeatureList';
import { Button, Card, Eyebrow, Metric, MetricRow, Screen, SectionTitle, Title } from '../components/primitives';
import {FallAlarmSettingsPanel} from '../../HardwareSettingsPanel';

export function CareScreen({ actions }: { actions: QsmartActions }) {
  const live=useLive(),{tracker,health,activity,locale} = live;
  const tokens = useTokens(), {colors,design,radius,shadows,spacing,touch,type} = tokens;
  const styles = makeStyles(tokens);
  return (
    <Screen testID="care-screen">
      <Title subtitle={hasFeature(live.state.snapshot?.device,'health')?(locale==="da-DK"?"Se målinger og udvikling.\nMål nu eller på faste tider.":"View readings and follow changes.\nStart a reading or schedule daily measurements."):(locale==='da-DK'?'Faldalarm, medicinpåmindelser og kontakt.':'Fall alerts, medication reminders and contact.')}>Omsorg</Title>
      {hasFeature(live.state.snapshot?.device,'fall')&&<FallAlarmSettingsPanel key={live.state.snapshot?.device?.id} locale={locale} palette={live.palette} state={live.state} session={live.session}/>}
      {hasFeature(live.state.snapshot?.device,'health')&&<Card>
        <View style={styles.measureHeading}><SectionTitle>Seneste målinger</SectionTitle><DailyMeasurements/><Button label="Ny måling" icon="measure" onPress={() => actions.openScreen('care-measure')} /></View>
        <MetricRow>
          {health.map((item) => <Metric key={item.label} label={item.label} value={item.value ?? 'Mangler'} note={item.measuredAt} icon={item.label === 'Puls' ? 'heart' : item.label === 'Blodtryk' ? 'pressure' : item.label === 'Temperatur' ? 'temperature' : 'oxygen'} />)}
        </MetricRow>
        <Text style={styles.disclaimer}>Målinger kan mangle eller være gamle. De vurderes ikke som normale eller unormale i appen.</Text>
      </Card>}
      <SectionTitle>Omsorg og kontakt</SectionTitle>
      <FeatureList features={featuresForTab('care').filter((feature) => feature.id !== 'care-measure'&&feature.id!=='device-fall')} onOpen={actions.openScreen} />
    </Screen>
  );
}

const makeStyles = ({colors,design,radius,shadows,spacing,touch,type}: ReturnType<typeof useTokens>) => StyleSheet.create({
  measureHeading: { gap: spacing.sm },
  metricGrid: { flexDirection: 'row', flexWrap: 'wrap', gap: spacing.md },
  disclaimer: { color: colors.textMuted, fontSize: type.body, lineHeight: type.line },
});

export const useStyles = () => makeStyles(useTokens());
